import dayjs from 'dayjs'
import type { Airport } from './airport-db'

export const BLOCK_SPEED_KNOTS = 450
export const TAXI_BUFFER_MINUTES = 30

const EARTH_RADIUS_NM = 3440.065

function toRadians(deg: number): number {
  return (deg * Math.PI) / 180
}

export function haversineDistanceNM(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const dLat = toRadians(lat2 - lat1)
  const dLon = toRadians(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) ** 2
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return EARTH_RADIUS_NM * c
}

export function estimateBlockTimeMinutes(distanceNM: number): number {
  const raw = (distanceNM / BLOCK_SPEED_KNOTS) * 60 + TAXI_BUFFER_MINUTES
  return Math.ceil(raw / 30) * 30
}

export function estimateArrivalDateTime(
  dep: Airport,
  arr: Airport,
  depDateTime: Date
): Date {
  const distance = haversineDistanceNM(
    dep.latitudeDeg,
    dep.longitudeDeg,
    arr.latitudeDeg,
    arr.longitudeDeg
  )
  const minutes = estimateBlockTimeMinutes(distance)
  return dayjs(depDateTime).add(minutes, 'minute').toDate()
}
